import React from 'react';

const RadioInput = ({ question, value, onChange, error }) => {
  return (
    <div className="question-input radio-group">
      {question.options.map((option) => (
        <label key={option.value} className="radio-option">
          <input
            type="radio"
            name={question.key}
            value={option.value}
            checked={value === option.value}
            onChange={(e) => onChange(e.target.value)}
            required={question.required}
          />
          <span className="radio-label">{option.label}</span>
        </label>
      ))}
      {error && <span className="error-message">{error}</span>}
    </div>
  );
};

export default RadioInput;